module.exports = __webpack_public_path__ + "img/hb-login_bg.471f0837.png";